import {
    BottomMenu,
    EventBus,
    Instance,
    Navigation,
    Objekt,
    Page,
    Service,
    State,
} from '@siposdani87/sui-js';
import { app } from '../app';
import { LanguageService } from './languageService';

export class FooterService extends Service {
    static readonly inject = ['instances', 'languageService'];

    eventBus: EventBus;
    bottomMenu: BottomMenu;
    state: State;
    page: Page;
    footerNavigation: Navigation;

    constructor(
        instances: Instance,
        private languageService: LanguageService,
    ) {
        super();

        this.eventBus = instances.eventBus;
        this.bottomMenu = instances.bottomMenu;
        this.state = instances.state;
        this.page = instances.page;

        this.footerNavigation = new Navigation();
    }

    enter() {
        this.eventBus.set('state.change', (state: Objekt) => {
            this.footerNavigation.setActive(state.get<string>('id'));
        });

        this._setFooterNavigation();
    }

    private _setFooterNavigation() {
        this.footerNavigation.addText(
            'site.landing-page',
            this.languageService.translate('captions.site.landing_page'),
            (href) => {
                this.state.go(href);
            },
            this.state.resolveUrl('site.landing-page'),
        );

        this.footerNavigation.addText(
            'site.policies',
            this.languageService.translate('captions.site.policies'),
            (href) => {
                this.state.go(href);
            },
            this.state.resolveUrl('site.policies', {
                tab: 'terms-of-service',
            }),
        );

        this.footerNavigation.addText(
            'feedback',
            this.languageService.translate('captions.site.feedback'),
            () => {
                const email =
                    this.languageService.translate('application.email');
                const subject = this.languageService.translate(
                    'captions.site.feedback',
                );
                this.page.mailTo(email, subject);
            },
        );

        this.footerNavigation.bindToContainer(this.bottomMenu.getContainer());
    }
}

export const footerService = app.service('footerService', FooterService);
